import { Link } from "react-router-dom";

/**
 * The link out of a preview section to its full list.
 *
 * An anchor rather than a button: it navigates, and styling navigation as a
 * button implies an action that changes something.
 */
export function ViewAllLink({
  to,
  children,
}: {
  to: string;
  children: string;
}) {
  return (
    <Link
      to={to}
      className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline"
    >
      {children}
    </Link>
  );
}
